const getCloudApiBaseUrl = () => process.env.REACT_APP_LIFT_NET_CLOUD_API_ONLINE || "";

const shouldUseOfflineBaseUrl =
  process.env.REACT_APP_SOCKET_DINAMIC_IP?.trim().toUpperCase() === "TRUE";

const normalizeOfflineBaseUrl = (baseUrl: string) => {
  const sanitizedBaseUrl = baseUrl.trim();
  if (!sanitizedBaseUrl) return "";
  if (sanitizedBaseUrl.startsWith(":")) {
    return `${window.location.protocol}//${window.location.hostname}${sanitizedBaseUrl}`;
  }
  return sanitizedBaseUrl;
};

const getBaseUrl = () =>
  shouldUseOfflineBaseUrl
    ? normalizeOfflineBaseUrl(process.env.REACT_APP_BACKEND_OFFLINE_PREFIX || "")
    : getCloudApiBaseUrl();

export default getBaseUrl;
